import { IApiLink } from "@/types"
import { ApiLinkEntity, ApiLinkRel } from "config/constants"
import { ImputedInterestRate, IGetImputedInterestRateDto } from "./ImputedInterestRate"

export enum StartDepreciationUsing {
    bookingPeriod = "bookingPeriod",
    invoiceDate = "invoiceDate",
}

export enum LocalCalculationRule {
    halfYear = "halfYear",
    acquisitionMonth = "acquisitionMonth",
}

export enum ConstructionMonth {
    june = "june",
    july = "july"
}

export interface IGetFinancialFactorsDto {
    imputedInterestRates: IGetImputedInterestRateDto[]
    isInterestRateEditable: boolean
    startDepreciationUsing?: StartDepreciationUsing
    minimumDepreciationPeriod?: number
    localCalculationRule?: LocalCalculationRule
    constructionMonth?: ConstructionMonth | null
    eTag?: string
    links?: IApiLink[]
}

export interface IPostFinancialFactorsDto {
    imputedInterestRate: number | null
    startDepreciationUsing: StartDepreciationUsing
    minimumDepreciationPeriod: number
    localCalculationRule: LocalCalculationRule
    constructionMonth: ConstructionMonth
}

export default class FinancialFactors {
    imputedInterestRates: ImputedInterestRate[]
    isInterestRateEditable: boolean
    minimumDepreciationPeriod?: number
    startDepreciationUsing?: StartDepreciationUsing
    localCalculationRule?: LocalCalculationRule
    constructionMonth?: ConstructionMonth | null
    eTag?: string
    linkGet?: IApiLink
    linkUpdate?: IApiLink
    linkAddPeriod?: IApiLink

    constructor(dto: IGetFinancialFactorsDto) {
        this.imputedInterestRates = dto.imputedInterestRates.map(val => new ImputedInterestRate(val))
        this.isInterestRateEditable = dto.isInterestRateEditable
        this.startDepreciationUsing = dto.startDepreciationUsing
        this.minimumDepreciationPeriod = dto.minimumDepreciationPeriod
        this.localCalculationRule = dto.localCalculationRule
        this.constructionMonth = dto.constructionMonth ?? null
        this.eTag = dto.eTag
        if (dto.links) {
            this.linkGet = dto.links.find(lnk => lnk.entity === ApiLinkEntity.financialFactors && lnk.rel === ApiLinkRel.self)
            this.linkUpdate = dto.links.find(lnk => lnk.entity === ApiLinkEntity.financialFactors && lnk.rel === ApiLinkRel.partialUpdate)
            this.linkAddPeriod = dto.links.find(lnk => lnk.entity === ApiLinkEntity.imputedInterestRatePeriod && lnk.rel === ApiLinkRel.new)
        }
    }

    get currentImputedInterest(): ImputedInterestRate | null {
        return this.imputedInterestRates?.[0] ?? null
    }
}
